var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "float-left q-mr-md q-mb-md" },
    [
      _c("q-btn", {
        attrs: {
          loading: _vm.loading.ticketTransfer,
          disable: _vm.disabled,
          color: _vm.SET_COLOR_BUTTON.primary,
          label: _vm.$t("button.exchangeTicket"),
          type: "a"
        },
        on: {
          click: function($event) {
            _vm.dialogTicketTransferModel = true
          }
        }
      }),
      _vm.disabled
        ? _c(
            "q-tooltip",
            { attrs: { self: "top middle", anchor: "bottom middle" } },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.getTooltipTranslationByVoucherOrTicket()) +
                  "\n  "
              )
            ]
          )
        : _vm._e(),
      _c("dialog-ticket-transfer", {
        attrs: { ticket: _vm.ticket },
        on: {
          "confirm-transfer": function($event) {
            _vm.handleTransferTicket($event)
          }
        },
        model: {
          value: _vm.dialogTicketTransferModel,
          callback: function($$v) {
            _vm.dialogTicketTransferModel = $$v
          },
          expression: "dialogTicketTransferModel"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }